import {
  Inject,
  inject,
  Injectable,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { FooterGateway } from './footer.gateway';
import { IFooter } from '@web/dtos';
import { AppConfigService } from '../../app-config.service';
import { PREVIEW_TOKEN } from '../../../constants/injectionTokens.constant';

@Injectable({
  providedIn: 'root',
})
export class MockFooterStore {
  private readonly gateway: FooterGateway = new FooterGateway();
  private readonly configService: AppConfigService = inject(AppConfigService);

  constructor(@Inject(PREVIEW_TOKEN) private previewData: IFooter) {}

  readonly isLoading: Signal<boolean> = signal(false);
  readonly footer: WritableSignal<IFooter> = signal(this.previewData);

  updateFooter(query: IFooter): void {
    this.footer.set(query);
  }

  save(query: IFooter): void {}

  requestPath(imageId: string | undefined, area: string): string {
    switch (area) {
      case 'paymentArea':
        return (
          this.configService.get().general.cmsUrl +
          '/images/' +
          this.footer().paymentArea.accessibleImages.filter(
            i => i.id === imageId
          )[0].image?.id
        );
      case 'logoArea':
        return (
          this.configService.get().general.cmsUrl +
          '/images/' +
          this.footer().logoArea.accessibleImages.filter(
            i => i.id === imageId
          )[0].image?.id
        );
      default:
        return '';
    }
  }

  backgroundImagePath(imageId: string | undefined): string {
    return this.configService.get().general.cmsUrl + '/images/' + imageId;
  }
}
